export default __webpack_public_path__ + "static/media/sumedh-inulkar.98e46978.jpeg";